import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-FP5H',
        },
    },
    host: 'www.zalando-lounge.com',
});
